import { apiSlice } from "./apiSlice";
import { CreateLassoSafeUserRequest, CreateLassoSafeUserResponse } from "../features/lasso-safe/types";

export const lassoSafeApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        createLassoSafeUser: builder.mutation<CreateLassoSafeUserResponse, CreateLassoSafeUserRequest>({
            query: (params) => {
                return {
                    url: `/lassosafe/users`,
                    method: 'POST',
                    body: params
                }
            }
        })
    })
});

export const {
    useCreateLassoSafeUserMutation,
} = lassoSafeApiSlice;